import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	getResourcePath,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationStatCard } from "web_myplann/Inspiration/Components/InspirationStatCard";
import type { InspirationStat } from "web_myplann/Inspiration/Types/InspirationTypes";
import { getInspirationStatColors } from "web_myplann/Inspiration/Utils/getInspirationStatColors";

type Props = {
	stats: InspirationStat[];
};

export const InspirationStatCardList: FC<Props> = ({ stats }) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack direction="row" gap={theme.spacingTokens.sm}>
			{stats.map((stat) => (
				<InspirationStatCard
					key={getResourcePath(stat.label)}
					label={t(stat.label)}
					amount={stat.amount}
					{...getInspirationStatColors(theme, stat.tone)}
				/>
			))}
		</Stack>
	);
};
